/* Product configurator: variant picker, layered preview, bundle galleries, custom fields and cart. */
(function () {
  'use strict';
  if (window.ProductConfig) return;

  function init(root) {
    var data = JSON.parse(root.querySelector('[data-bc-json]').textContent);
    var variants = data.variants;
    var fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: data.currency });
    var money = function (cents) { return fmt.format(cents / 100); };

    var one = function (sel, scope) { return (scope || root).querySelector(sel); };
    var all = function (sel, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(sel)); };
    // Elements that belong to this owner, not to an owner nested inside it
    var own = function (owner, sel) {
      return all(sel, owner).filter(function (n) { return n.closest('[data-bc-owner]') === owner; });
    };

    // Reads the body as text and parses it ourselves: Safari (iOS) throws a vague
    // "The string did not match the expected pattern" from response.json() on an empty or non-JSON body
    function requestJson(url, options) {
      return fetch(url, options).then(function (r) {
        return r.text().then(function (text) {
          var body = null;
          try { body = text ? JSON.parse(text) : null; } catch (err) { body = null; }
          return { ok: r.ok, status: r.status, body: body };
        });
      });
    }

    var groups = all('[data-bc-option]');
    var items = all('[data-bc-item]');
    var fields = all('[data-bc-field]');
    var previewFields = fields.filter(function (f) { return f.dataset.previewLayer === '1'; });
    var stage = one('[data-bc-stage]');
    var base = one('[data-bc-base]');
    var readout = one('[data-bc-readout]');
    var qtyInput = one('[data-bc-qty]');
    var totalEl = one('[data-bc-total]');
    var savingsEl = one('[data-bc-savings]');
    var addBtn = one('[data-bc-add]');
    var addLabelEl = one('[data-bc-add-label]') || addBtn;
    var statusEl = one('[data-bc-status]');
    var addLabel = addLabelEl.textContent.trim();
    var baseDefault = base ? base.getAttribute('src') : '';

    /* ---------- Preview layers (bundle items and swatch images share one set of helpers) ---------- */
    function placeLayer(owner) {
      var img = owner._layer, d = owner.dataset;
      if (d.fill === '1') { img.classList.add('bc__layer--fill'); return; }
      img.style.left = d.x + '%';
      img.style.top = d.y + '%';
      img.style.width = d.size + '%';
      img.style.transform = 'translate(-50%, -50%) rotate(' + d.rotate + 'deg)';
    }

    function addLayer(owner, z, extraClass) {
      var img = document.createElement('img');
      img.className = 'bc__layer' + (extraClass ? ' ' + extraClass : '');
      img.alt = owner.dataset.name || '';
      img.draggable = false;
      img.style.zIndex = String(z);
      img.addEventListener('error', function () { img.classList.remove('is-on'); });
      owner._layer = img;
      placeLayer(owner);
      stage.appendChild(img);
    }

    function showLayer(owner, src) {
      var img = owner._layer;
      if (!img) return;
      if (src) {
        if (img.getAttribute('src') !== src) img.setAttribute('src', src);
        img.classList.add('is-on');
      } else {
        img.classList.remove('is-on');
      }
    }

    // Theme editor only: drag a layer on the preview to find its X / Y
    function enableDrag(owner, label) {
      var img = owner._layer, dragging = false;
      function move(e) {
        var r = stage.getBoundingClientRect();
        owner.dataset.x = Math.round(Math.min(100, Math.max(0, (e.clientX - r.left) / r.width * 100)));
        owner.dataset.y = Math.round(Math.min(100, Math.max(0, (e.clientY - r.top) / r.height * 100)));
        placeLayer(owner);
        readout.hidden = false;
        readout.textContent = label + ' — X: ' + owner.dataset.x + ', Y: ' + owner.dataset.y + ', Size: ' + owner.dataset.size + '. Enter these in the block settings.';
      }
      img.addEventListener('pointerdown', function (e) { dragging = true; img.setPointerCapture(e.pointerId); move(e); });
      img.addEventListener('pointermove', function (e) { if (dragging) move(e); });
      img.addEventListener('pointerup', function () { dragging = false; });
    }

    /* ---------- Choices: bundle item galleries and metaobject galleries ---------- */
    function toggleChoice(owner, btn) {
      owner._choice = owner._choice === btn ? null : btn;
      own(owner, '[data-bc-choice]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === owner._choice ? 'true' : 'false');
      });
      var line = own(owner, '[data-bc-selected]')[0];
      if (line) {
        line.textContent = owner._choice ? (line.dataset.prefix ? line.dataset.prefix + ' ' : '') + owner._choice.dataset.title : line.dataset.empty;
        line.classList.toggle('is-empty', !owner._choice);
      }
      if (owner.hasAttribute('data-bc-mo')) {
        owner.dataset.value = owner._choice ? owner._choice.dataset.tag : '';
        showLayer(owner, owner._choice ? owner._choice.dataset.preview : '');
      }
    }

    function firstChoice(owner, needPreview) {
      if (owner._choice) return;
      var first = own(owner, '[data-bc-choice]').find(function (b) {
        return !b.disabled && (!needPreview || b.dataset.preview);
      });
      if (first) toggleChoice(owner, first);
    }

    // The chosen variant's own image, else the block's layer image, else the product photo
    function itemLayerSrc(item) {
      var c = item._choice;
      return c ? (c.dataset.img || item.dataset.layer || item.dataset.fallback || '') : '';
    }

    items.forEach(function (item, i) { item._choice = null; addLayer(item, 10 + i); });
    previewFields.forEach(function (f) { addLayer(f, f.dataset.z || 0, 'bc__layer--mo'); });

    if (data.design) {
      stage.classList.add('is-editing');
      items.forEach(function (item) { firstChoice(item); enableDrag(item, item.dataset.name); });
      previewFields.forEach(function (f) {
        firstChoice(f, true);
        if (f.dataset.fill !== '1') enableDrag(f, f.dataset.layerName + ' (swatch layer)');
      });
    } else if (data.preselect) {
      items.forEach(function (item) { firstChoice(item); });
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-bc-choice]') : null;
      if (!btn || btn.disabled || !root.contains(btn)) return;
      var owner = btn.closest('[data-bc-owner]');
      if (!owner) return;
      toggleChoice(owner, btn);
      update();
    });

    /* ---------- Custom fields: dropdowns, text blocks, metaobject galleries ---------- */
    // Fields placed inside a bundle item only show while that item has a variant selected
    function updateFields() {
      fields.forEach(function (f) {
        var item = f.closest('[data-bc-item]');
        if (!item) return;
        f.hidden = !item._choice;
        if (item._choice) return;
        var select = one('[data-bc-custom]', f);
        if (select) select.value = '';
        if (f._choice) toggleChoice(f, f._choice);
      });
    }

    function collectFields() {
      var tags = [], missing = null;
      fields.forEach(function (f) {
        if (f.hidden) return;
        var select = one('[data-bc-custom]', f);
        var isMo = f.hasAttribute('data-bc-mo');
        var value = select ? select.value : (isMo ? f.dataset.value : '');
        if (value) tags.push(value.replace(/,/g, ' ').trim());
        else if (!missing && (select || isMo) && (select ? select.dataset.required : f.dataset.required)) {
          missing = select || one('[data-bc-choice]', f);
        }
      });
      return { tags: tags, missing: missing };
    }

    function escapeRe(t) { return t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

    // Adds the chosen tags to the cart note, which Shopify carries onto the order as its note
    function writeNote(tags) {
      if (!tags.length) return Promise.resolve();
      var label = data.noteLabel || 'Configurator tags';
      return requestJson(data.cartJsonUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (res) {
          var note = (res.body && res.body.note) || '';
          var re = new RegExp('^' + escapeRe(label) + ':[ \\t]*(.*)$', 'm');
          var m = note.match(re);
          var list = m ? m[1].split(',').map(function (t) { return t.trim(); }).filter(Boolean) : [];
          tags.forEach(function (t) { if (t && list.indexOf(t) < 0) list.push(t); });
          var line = label + ': ' + list.join(', ');
          note = m ? note.replace(re, function () { return line; }) : (note ? note + '\n' + line : line);
          return requestJson(data.cartUpdateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ note: note })
          });
        })
        .catch(function () { /* the cart add already succeeded; don't block checkout over the note */ });
    }

    /* ---------- Primary product variant ---------- */
    function selection() {
      return groups.map(function (g) {
        var checked = one('input:checked', g);
        if (checked) return checked.value;
        var select = one('select', g);
        return select ? select.value : null;
      });
    }
    function matches(v, sel) {
      return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; });
    }
    function currentVariant() {
      if (!groups.length) return variants[0];
      var sel = selection();
      return variants.find(function (v) { return matches(v, sel); }) || null;
    }
    function hasStock(sel, index, value) {
      var test = sel.slice();
      test[index] = value;
      return variants.some(function (v) { return v.available && matches(v, test); });
    }

    function markAvailability() {
      var sel = selection();
      groups.forEach(function (g, gi) {
        all('input', g).forEach(function (input) {
          input.closest('label').classList.toggle('is-unavailable', !hasStock(sel, gi, input.value));
        });
        all('option', g).forEach(function (opt) {
          opt.textContent = opt.dataset.label + (hasStock(sel, gi, opt.value) ? '' : ' (unavailable)');
        });
      });
    }

    function setBase(v) {
      if (!base) return;
      var src = v && v.featured_image && v.featured_image.src ? v.featured_image.src : baseDefault;
      if (base.getAttribute('src') !== src) base.setAttribute('src', src);
    }

    /* ---------- Quantity, totals, button ---------- */
    function clampQty(n) {
      var min = data.minQty > 0 ? data.minQty : 1;
      if (!(n > 0)) n = min;
      n = Math.max(min, n);
      return data.maxQty > 0 ? Math.min(data.maxQty, n) : n;
    }
    function qty() { return clampQty(parseInt(qtyInput.value, 10)); }

    function selectedBundle() {
      return items.filter(function (item) { return !!item._choice; }).map(function (item) {
        return { id: parseInt(item._choice.dataset.id, 10), price: parseInt(item._choice.dataset.price, 10) };
      });
    }

    function setStatus(msg, isError) {
      statusEl.textContent = msg || '';
      statusEl.classList.toggle('is-error', !!isError);
    }

    function updateButton(v) {
      var label = addLabel;
      if (!v) label = 'Unavailable';
      else if (!v.available) label = data.soldOutLabel || 'Sold out';
      addBtn.disabled = !v || !v.available;
      addLabelEl.textContent = label;
    }

    function update() {
      updateFields();
      markAvailability();
      var v = currentVariant();
      var bundle = selectedBundle();
      var q = qty();

      setBase(v);

      items.forEach(function (item) {
        one('[data-bc-item-price]', item).textContent = item._choice ? money(parseInt(item._choice.dataset.price, 10)) : '';
        showLayer(item, itemLayerSrc(item));
      });

      var bundleSum = bundle.reduce(function (sum, b) { return sum + b.price; }, 0);
      totalEl.textContent = money(((v ? v.price : 0) + bundleSum) * q);

      var showSavings = data.discountPercent > 0 && bundle.length > 0;
      savingsEl.hidden = !showSavings;
      if (showSavings) savingsEl.textContent = 'Bundle saving: ' + money(Math.round(bundleSum * q * data.discountPercent / 100));

      updateButton(v);

      if (v && groups.length && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      // Lets a theme developer react to changes (gallery swap, SKU, etc.)
      root.dispatchEvent(new CustomEvent('product-config:change', { bubbles: true, detail: { variant: v, bundle: bundle, quantity: q } }));
    }

    function addToCart() {
      var v = currentVariant();
      if (!v || !v.available) return;

      var cf = collectFields();
      if (cf.missing) {
        setStatus('Choose an option for "' + (cf.missing.dataset.name || 'this field') + '".', true);
        cf.missing.focus();
        return;
      }

      var bundle = selectedBundle(), q = qty();
      var bundleId = 'b' + Date.now().toString(36);
      var line = function (id) {
        var item = { id: id, quantity: q };
        if (bundle.length) item.properties = { _bundle: bundleId };
        return item;
      };
      var lines = [line(v.id)].concat(bundle.map(function (b) { return line(b.id); }));

      addBtn.disabled = true;
      setStatus('Adding to cart…');
      requestJson(data.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: lines })
      })
        .then(function (res) {
          if (!res.ok) {
            var detail = res.body && (res.body.description || res.body.message);
            throw new Error(detail || 'Could not add to cart (error ' + res.status + ').');
          }
          return writeNote(cf.tags).then(function () { return res; });
        })
        .then(function (res) {
          setStatus('Added to cart.');
          document.dispatchEvent(new CustomEvent('product-config:added', { detail: res.body }));
          if (data.redirect === 'cart') window.location.href = data.cartUrl;
          else addBtn.disabled = false;
        })
        .catch(function (err) { setStatus(err.message, true); addBtn.disabled = false; });
    }

    /* ---------- Wire up ---------- */
    var minusBtn = one('[data-bc-minus]');
    var plusBtn = one('[data-bc-plus]');
    root.addEventListener('change', update);
    if (minusBtn) minusBtn.addEventListener('click', function () { qtyInput.value = clampQty(qty() - 1); update(); });
    if (plusBtn) plusBtn.addEventListener('click', function () { qtyInput.value = clampQty(qty() + 1); update(); });
    qtyInput.addEventListener('input', update);
    qtyInput.addEventListener('change', function () { qtyInput.value = qty(); });
    addBtn.addEventListener('click', addToCart);

    qtyInput.value = qty();
    update();
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-bc-root]'), function (root) {
      if (root._bcReady) return;
      root._bcReady = true;
      init(root);
    });
  }

  window.ProductConfig = { init: initAll };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  // Theme editor: sections are re-rendered in place
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
